import { render, staticRenderFns } from "./SubscriptionItem.vue?vue&type=template&id=77a4a43f&"
import script from "./SubscriptionItem.vue?vue&type=script&lang=js&"
export * from "./SubscriptionItem.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionItem.vue?vue&type=style&index=0&id=77a4a43f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports